import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Right from "./Right";
import { server } from "../../server";

export default function SearchResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const filter = location.state?.filter;

  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    console.log("API Profiles:", profiles);
  }, [profiles]);

  const buildFilterPayload = (filter) => {
    if (!filter) return null;

    const payload = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        Array.isArray(value) &&
        value.length > 0 &&
        !value.includes("Open to All")
      ) {
        payload[key] = value;
      }
    });

    return Object.keys(payload).length ? payload : null;
  };

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const payload = buildFilterPayload(filter);
        if (!payload) {
          setProfiles([]);
          setLoading(false);
          return;
        }

        const res = await fetch(`${server}/filter`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok || !data.success) {
          throw new Error(data.message || "API call failed");
        }

        setProfiles(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, [filter]);

  return (
    <>
      <Header />
      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div className="d-flex align-items-center mb-3">
                <Link
                  onClick={() => navigate(-1)}
                  className="icon-shape me-3 icon-lg bg-light-red rounded-circle"
                >
                  <i className="bi bi-chevron-left fs-3 text-primary"></i>
                </Link>
                <div>
                  <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                    Search Results
                  </h3>
                  <p className="lh-sm fw-normal m-0">
                    Matches / Profiles from Search result.
                  </p>
                </div>
              </div>

              {loading ? (
                <div className="d-flex justify-content-center mt-4">
                  <div
                    className="spinner-border text-danger"
                    role="status"
                  ></div>
                </div>
              ) : error ? (
                <p className="text-center text-danger mt-4">{error}</p>
              ) : profiles.length === 0 ? (
                <p className="text-center mt-4">No profiles found.</p>
              ) : (
                <div className="row g-2">
                  {profiles.map((item) => (
                    <div className="col-lg-4 col-md-6 col-12" key={item._id}>
                      <div
                        className="position-relative rounded-4 d-flex align-items-end"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/profile", {
                            state: { profileId: item._id },
                          })
                        }
                      >
                        <img
                          src={
                            item?.images?.[0]?.docUrl ||
                            "/assets/images/default-profile.jpg"
                          }
                          className="w-100 object-fit-cover rounded-4"
                          height="380"
                          alt=""
                        />

                        <div className="position-absolute p-3 dark-gradient w-100 rounded-4 d-flex justify-content-between flex-column h-100">
                          <div className="d-flex justify-content-end align-items-center">
                            {item?.images?.length > 0 && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/images", {
                                    state: { profileId: item._id },
                                  });
                                }}
                                className="icon-shape icon-sm bg-white rounded-circle"
                              >
                                <i className="bi bi-image fs-4"></i>
                              </div>
                            )}
                          </div>

                          <div>
                            <p className="text-uppercase text-white m-0 lh-sm fs-6 fw-semibold">
                              GR{item?.userId}
                            </p>
                            <h4 className="fw-normal ls-sm fw-medium text-white lh-1 mt-1 mb-0">
                              {item?.name},{" "}
                              {Math.floor(
                                (Date.now() -
                                  new Date(item?.profile?.dob).getTime()) /
                                  3.15576e10
                              )}{" "}
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/8207/8207939.png"
                                width="20"
                                className="ms-1"
                                alt=""
                              />
                            </h4>

                            <p className="d-flex align-items-center m-0 lh-sm mt-2 text-white fs-6">
                              {item?.profile?.height}{" "}
                              <i className="bi bi-circle-fill fs-dot mx-2"></i>{" "}
                              {item?.profile?.community}
                            </p>
                            <p className="d-flex align-items-center m-0 lh-sm text-white fs-6">
                              {item?.profile?.profession || "No Profession"}{" "}
                              <i className="bi bi-circle-fill fs-dot mx-2"></i>{" "}
                              {item?.profile?.annualIncome || "No Income"}
                            </p>
                            <p className="d-flex align-items-center m-0 lh-sm text-white fs-6">
                              {item?.profile?.religion}{" "}
                              <i className="bi bi-circle-fill fs-dot mx-2"></i>{" "}
                              {item?.profile?.maritalStatus}
                            </p>

                            <div className="bg-light-gradient-right ms-n4 p-1 mt-4 mb-2">
                              <p className="text-dark m-0 lh-sm fw-normal ms-3 fs-6 fst-italic">
                                Profile Managed by {item?.profileFor}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}
